import { render, staticRenderFns } from "./ModelPerformanceSummary.vue?vue&type=template&id=12bb1d0a&scoped=true"
import script from "./ModelPerformanceSummary.vue?vue&type=script&lang=js"
export * from "./ModelPerformanceSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bb1d0a",
  null
  
)

export default component.exports